"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _ContentBlock = _interopRequireDefault(require("../../components/Divs/ContentBlock"));
var _StepCompletionNotif = _interopRequireDefault(require("../../components/Modals/StepCompletionNotif"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _DropZoneModal = _interopRequireDefault(require("../../components/Modals/DropZoneModal"));
var _ClassAndDivisionDetails = _interopRequireDefault(require("../ClassesDivisions/ClassAndDivisionDetails"));
var Theme = _interopRequireWildcard(require("../../theme"));
var _CensusForm = _interopRequireDefault(require("./CensusForm"));
var _CensusTable = _interopRequireDefault(require("./CensusTable"));
var _styles = require("@mui/material/styles");
var _censusFormExample = _interopRequireDefault(require("../../assets/census-form-example.png"));
var _csv = _interopRequireDefault(require("../../assets/csv.png"));
var _xls = _interopRequireDefault(require("../../assets/xls.png"));
var _numbers = _interopRequireDefault(require("../../assets/numbers.png"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledLink = (0, _styles.styled)('a')(function (_ref) {
  var theme = _ref.theme;
  return {
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-around',
    margin: '10px',
    padding: '10px',
    backgroundColor: Theme.colors.lightGrey,
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    '&:hover': {
      boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px -1px rgba(0, 0, 0, 0.12)',
      filter: 'brightness(97%)'
    }
  };
});
var Census = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Census, _PureComponent);
  function Census() {
    var _this;
    (0, _classCallCheck2["default"])(this, Census);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Census, [].concat(args)), _this.state = {
      showNewEmployee: false,
      currentEmployee: null,
      successDialogOpen: false,
      showDropZone: false,
      showExplanation: false,
      censusForm: false,
      largePhoto: false,
      showTemplateModal: false,
      failedRecords: null
    }, _this._submitCensus = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var success;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.props.submitCensus(_this.props.accountID);
          case 2:
            success = _context.sent;
            if (success) {
              _this.setState({
                successDialogOpen: true
              });
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._submitFile = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(files) {
        var form, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              form = new FormData();
              form.append('file', files[0]);
              _context2.next = 4;
              return _this.props.uploadCensus(form, _this.props.accountID);
            case 4:
              response = _context2.sent;
              if (response.failedRecords) {
                _this.setState({
                  failedRecords: response.failedRecords
                });
              }
              return _context2.abrupt("return", false);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), _this._closeSuccessDialog = function () {
      _this.setState({
        successDialogOpen: false
      });
    }, _this._goToNextStep = function () {
      _this.setState({
        successDialogOpen: false
      });
      _this.props.setSelectedSection(null);
    }, _this._toggle = function (type) {
      _this.setState((0, _defineProperty2["default"])({}, type, !_this.state[type]));
    }, _this._toggleCensusFormExplanation = function () {
      _this.setState({
        showExplanation: !_this.state.showExplanation,
        currentEmployee: null,
        showClassAndDivisionDetailsModal: false
      });
    }, _this._toggleAddCensusForm = function () {
      _this.setState({
        showExplanation: false,
        showDropZone: !_this.state.showDropZone
      });
    }, _this._toggleShowEmployee = function () {
      _this.setState({
        showNewEmployee: !_this.state.showNewEmployee,
        currentEmployee: null,
        showClassAndDivisionDetailsModal: false
      });
    }, _this._showClassAndDivisionDetailsModal = function () {
      _this.setState({
        showClassAndDivisionDetailsModal: !_this.state.showClassAndDivisionDetailsModal,
        showNewEmployee: false
      });
    }, _this._selectEmployee = function (employee) {
      _this.setState({
        showNewEmployee: true,
        currentEmployee: _objectSpread({}, employee)
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(Census, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var styles = {
        customMaxWidth: {
          maxWidth: 'unset !important'
        },
        censusExample: {
          marginTop: 20,
          height: 'auto',
          width: '100%',
          cursor: 'pointer',
          boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
          '&:hover': {
            boxShadow: 'none',
            transition: 'all 0.1s ease-out'
          }
        },
        censusExampleLarge: {
          position: 'relative',
          height: 'auto',
          width: '100%',
          zIndex: '9999'
        },
        contentBlockHeight: {
          maxHeight: '1000px'
        },
        btnGroup: {
          marginTop: '20px'
        },
        link: {
          textDecoration: 'none',
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-around',
          margin: '10px',
          padding: '10px',
          backgroundColor: Theme.colors.lightGrey,
          boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
          '&:hover': {
            boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px -1px rgba(0, 0, 0, 0.12)',
            filter: 'brightness(97%)'
          }
        },
        logo: {
          display: 'block',
          maxHeight: '50px',
          maxWidth: '100px'
        }
      };
      var userFields = [{
        name: _i18n["default"].t(_tokens["default"].labels.firstname)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.lastname)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.email)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees["class"]),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.mustAlreadyBeCreated)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees.division),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.mustAlreadyBeCreated)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.birthdate),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.dateFormat)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees.hireDate),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.dateFormat)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.gender),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.genderOptions)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees.occupation)
      }, {
        name: _i18n["default"].t(_tokens["default"].titles.coverage),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.planOptions)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.province),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.abbreviatedValues)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees.earningsType),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.earningsTypeOptions)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees.salary),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.salaryRequirement)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees.hoursPerWeek),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.hourlyRequirement)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees.hourlyWage),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.hourlyRequirement)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.employees.payrollID)
      }, {
        name: _i18n["default"].t(_tokens["default"].labels.signup.language),
        subtext: _i18n["default"].t(_tokens["default"].labels.census.languageInstructions)
      }];
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.currentAccountMeta.status === 3 && this.props.currentAccountMeta.state <= 4 || this.props.currentAccountMeta.status === 0 && this.props.currentAccountMeta.state === 0 ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.census.censusData),
        subtitle: _i18n["default"].t(_tokens["default"].labels.census.youCanAddEmployeesByBulkCsvUpload),
        btn: true,
        btnName: _i18n["default"].t(_tokens["default"].buttons.submitCensus),
        btnOnClick: this._submitCensus,
        btn2: true,
        btnName2: _i18n["default"].t(_tokens["default"].buttons.addCensusSheet),
        btnOnClick2: this._toggleCensusFormExplanation
      }) : /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.census.censusData),
        subtitle: _i18n["default"].t(_tokens["default"].labels.census.addEmployeesInstructions),
        btn: true,
        btnName: _i18n["default"].t(_tokens["default"].buttons.addCensusSheet),
        btnOnClick: this._toggleCensusFormExplanation
      }), this.state.showNewEmployee && /*#__PURE__*/_react["default"].createElement(_CensusForm["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.employees.employee),
        close: this._toggleShowEmployee,
        currentEmployee: this.state.currentEmployee,
        classData: this.props.classData,
        divisions: this.props.divisions,
        accountID: this.props.accountID,
        currentAccountMeta: this.props.currentAccountMeta,
        addUser: this.props.addUser,
        updateUser: this.props.updateUser,
        removeUser: this.props.removeUser,
        isMasterSite: this.props.isMasterSite,
        disableEditHireDate: this.props.disableEditHireDate
      }), this.state.showClassAndDivisionDetailsModal && /*#__PURE__*/_react["default"].createElement(_ClassAndDivisionDetails["default"], {
        divisions: this.props.divisions,
        classesData: this.props.classData,
        showModal: this.state.showClassAndDivisionDetailsModal,
        hideModal: this._showClassAndDivisionDetailsModal
      }), this.state.largePhoto ? /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        fullWidth: true,
        maxWidth: "xl",
        open: this.state.largePhoto,
        close: function close() {
          return _this2._toggle('largePhoto');
        },
        title: _i18n["default"].t(_tokens["default"].labels.census.requiredColumnsForCensusForm),
        customContainerStyle: styles.customMaxWidth
      }, /*#__PURE__*/_react["default"].createElement("img", {
        onClick: function onClick() {
          return _this2._toggle('largePhoto');
        },
        alt: "Example Census Document Large",
        src: _censusFormExample["default"],
        style: styles.censusExampleLarge
      })) : /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showExplanation,
        close: this._toggleCensusFormExplanation,
        title: _i18n["default"].t(_tokens["default"].labels.census.uploadCensusForm),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this._toggleAddCensusForm,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons["continue"]),
        customContainerStyle: {
          maxWidth: "600px"
        },
        customTitleIconWrapperStyle: {
          height: "49.31px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true,
        customStyle: {
          height: "45.75px"
        }
      }, _i18n["default"].t(_tokens["default"].labels.census.youMustProvideASheet)), userFields.map(function (field) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: field.name,
          style: {
            marginTop: 5,
            height: "20.52px"
          }
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          small: true,
          bold: true,
          display: "inline"
        }, "\u25CF ", field.name), field.subtext && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          key: field.subtext,
          tiny: true,
          display: "inline"
        }, "\xA0-\xA0", field.subtext));
      }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        sx: _objectSpread(_objectSpread({}, styles.btnGroup), {}, {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center"
        })
      }, this.state.showTemplateModal ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true
      }, _i18n["default"].t(_tokens["default"].labels.census.chooseTemplateFileType)), /*#__PURE__*/_react["default"].createElement(StyledLink, {
        href: "https://d6hvupc5g7lnm.cloudfront.net/files/census-form.csv",
        download: "census-form.csv"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "File type icon",
        src: _csv["default"],
        style: styles.logo
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        customStyle: {
          textAlign: 'right'
        }
      }, ".csv")), /*#__PURE__*/_react["default"].createElement(StyledLink, {
        href: "https://d6hvupc5g7lnm.cloudfront.net/files/census-form.xlsx",
        download: "census-form.xlsx"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "File type icon",
        src: _xls["default"],
        style: styles.logo
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        customStyle: {
          textAlign: 'right'
        }
      }, ".xlsx")), /*#__PURE__*/_react["default"].createElement(StyledLink, {
        href: "https://d6hvupc5g7lnm.cloudfront.net/files/census-form.numbers",
        download: "census-form.numbers"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "File type icon",
        src: _numbers["default"],
        style: styles.logo
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        customStyle: {
          textAlign: 'right'
        }
      }, ".numbers"))) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this2._toggle('showTemplateModal');
        },
        transparent: true
      }, _i18n["default"].t(_tokens["default"].buttons.downloadBlankTemplate)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        marginTop: "10px",
        medium: true,
        light: true
      }, _i18n["default"].t(_tokens["default"].labels.census.viewTemplate))), /*#__PURE__*/_react["default"].createElement("img", {
        onClick: function onClick() {
          return _this2._toggle('largePhoto');
        },
        alt: "Example Census Document",
        title: _i18n["default"].t(_tokens["default"].labels.census.viewDocumentExpanded),
        src: _censusFormExample["default"],
        style: styles.censusExample
      })), this.state.showDropZone && /*#__PURE__*/_react["default"].createElement(_DropZoneModal["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.census.selectCsvFiles),
        hideModal: this._toggleAddCensusForm,
        showModal: this.state.showDropZone,
        maxItems: 1,
        type: "Census Form",
        submitFile: this._submitFile,
        acceptedFiles: "text/csv, .csv"
      }), /*#__PURE__*/_react["default"].createElement(_ContentBlock["default"], {
        style: styles.contentBlockHeight
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        display: "block",
        align: "left",
        margin: "20px 0",
        customLinkStyle: {
          lineHeight: '40px'
        }
      }, _i18n["default"].t(_tokens["default"].labels.census.censusData)), this.state.failedRecords && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        color: "red",
        margin: "0 0 10px 0"
      }, "The census file upload failed due to the below file errors. Please correct the records and re-upload the census file."), Object.keys(this.state.failedRecords).map(function (index) {
        var record = _this2.state.failedRecords[index];
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginTop: 10
          }
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          color: "red"
        }, "Record ".concat(index, " for ").concat(record.row["first name"], " ").concat(record.row["last name"], " failed for the following reason(s): ")), record.failureVerbiages.map(function (verbiage) {
          return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
            small: true,
            margin: "0 0 0 20px"
          }, "\u2022\xA0\xA0", verbiage);
        }));
      })), this.props.currentAccountMeta.status === 3 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "red",
        margin: "0 0 20px 0"
      }, _i18n["default"].t(_tokens["default"].labels.census.revisionNotice)), this.state.failedRecords ? null : this.props.census.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _i18n["default"].t(_tokens["default"].labels.census.noCensusData)) : /*#__PURE__*/_react["default"].createElement(_CensusTable["default"], {
        census: this.props.census,
        classData: this.props.classData,
        divisions: this.props.divisions,
        onSelectUser: this._selectEmployee,
        style: {
          fontFamily: 'inherit'
        }
      }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        style: _objectSpread(_objectSpread({}, styles.btnGroup), {}, {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end"
        })
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this._showClassAndDivisionDetailsModal,
        transparent: true
      }, _i18n["default"].t(_tokens["default"].buttons["classes & divisions"])), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        testid: "add-employee",
        transparent: true,
        onClick: this._toggleShowEmployee
      }, /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        style: {
          lineHeight: '21px',
          color: 'inherit'
        }
      }), "\xA0", _i18n["default"].t(_tokens["default"].labels.employees.employee)))), /*#__PURE__*/_react["default"].createElement(_StepCompletionNotif["default"], {
        dialog: _i18n["default"].t(_tokens["default"].labels.census.successfulSubmission),
        type: "Census",
        open: this.state.successDialogOpen,
        handleClose: this._closeSuccessDialog,
        handleNext: this._goToNextStep,
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        maxWidth: "550px"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        id: "census-data"
      }));
    }
  }]);
  return Census;
}(_react.PureComponent);
var _default = exports["default"] = Census;